import { render, staticRenderFns } from "./departmentIntroduction.vue?vue&type=template&id=81466f3a&scoped=true&"
import script from "./departmentIntroduction.vue?vue&type=script&lang=js&"
export * from "./departmentIntroduction.vue?vue&type=script&lang=js&"
import style0 from "./departmentIntroduction.vue?vue&type=style&index=0&id=81466f3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81466f3a",
  null
  
)

export default component.exports